import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import {from, lastValueFrom, Observable} from 'rxjs';
import {inject} from '@angular/core';
import {ContractorService} from '../services/contractor.service';

export const backendInterceptor: HttpInterceptorFn = (httpRequest: HttpRequest<unknown>, httpHandlerFn: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (httpRequest.url.startsWith('https://${backend}')) {
    const contractorService: ContractorService = inject(ContractorService);

    const intercept: () => Promise<HttpEvent<unknown>> = async (): Promise<HttpEvent<unknown>> => {
      const backend: string = contractorService.selectedContractorOld?.backend;

      httpRequest = httpRequest.clone({
        url: httpRequest.url.replace('https://${backend}', backend)
      });

      let response: HttpEvent<unknown>;

      try {
        response = await lastValueFrom(httpHandlerFn(httpRequest));
      } catch (err: any) {
        throw err;
      }

      return response;
    }

    return from(intercept());
  }

  return httpHandlerFn(httpRequest);
}
